import { useState, useEffect } from 'react';

export const useVideoModulePlaylist = (videos) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (videos.length > 0) {
      setCurrentIndex(0);
    }
  }, [videos]);

  const nextVideo = () => {
    setCurrentIndex((prevIndex) => {
      if (prevIndex < videos.length - 1) {
        return prevIndex + 1;
      }
      return prevIndex;
    });
  };

  const selectVideo = (index) => {
    if (index >= 0 && index < videos.length) {
      setCurrentIndex(index);
    }
  };

  return {
    currentVideo: videos[currentIndex],
    nextVideo,
    hasNext: currentIndex < videos.length - 1,
    selectVideo,
  };
};
